<template>
  <v-card>
    <div class="modal-header">
      <h3 class="modal-title">
        Detalhes da Solicitação
      </h3>
      <div
        class="options-container"
      >
        <v-tooltip
          v-if="!showSaveButton"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-menu
              v-model="showOptionsMenu"
              offset-y
              bottom
              left
            >
              <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
                <v-btn
                  icon
                  color="#E7E3FC"
                  v-bind="{ ...attrs, ...attrsMenu }"
                  v-on="{ ...on, ...onMenu }"
                >
                  <v-icon size="20">
                    {{ icons.mdiCog }}
                  </v-icon>
                </v-btn>
              </template>
              <v-card class="options-menu-card">
                <div
                  v-for="(option, index) in filteredMenuOptions"
                  :key="index"
                  class="option-item"
                  @click="handleMenuOption(option.action)"
                >
                  <v-icon
                    :color="option.iconColor"
                    size="20"
                  >
                    {{ option.icon }}
                  </v-icon>
                  <span style="color: #E7E3FC;">
                    {{ option.title }}
                  </span>
                </div>
              </v-card>
            </v-menu>
          </template>
          <span>Opções</span>
        </v-tooltip>
        <div
          v-if="showSaveButton"
          class="d-flex align-center"
          style="gap: 10px;"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="#E7E3FC"
                v-bind="attrs"
                v-on="on"
                @click="handleMenuOption('cancel-edit')"
              >
                <v-icon>{{ icons.mdiArrowLeft }}</v-icon>
              </v-btn>
            </template>
            <span>Cancelar edição</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
                @click="handleMenuOption('save')"
              >
                <v-icon>{{ icons.mdiContentSave }}</v-icon>
              </v-btn>
            </template>
            <span>Salvar</span>
          </v-tooltip>
        </div>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="#E7E3FC"
              v-bind="attrs"
              v-on="on"
              @click="openHistoryModal"
            >
              <v-icon size="20">{{ icons.mdiTimelineCheckOutline }}</v-icon>
            </v-btn>
          </template>
          <span>Abrir histórico</span>
        </v-tooltip>

        <v-btn
          icon
          @click="closeModal"
        >
          <v-icon size="30">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>
    </div>

    <div class="modal-content">
      <div class="tabs-container">
        <div
          v-for="(badge, index) in badges"
          :key="index"
          v-if="badge.menuValue !== 'trip' || canShowTripTab"
          class="badge-item"
        >
          <v-tooltip
            v-if="!canAccessTab(badge.menuValue)"
            bottom
            color="warning"
          >
            <template #activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
              >
                <BadgeDt
                  :icon="badge.icon"
                  :title="badge.title"
                  :subtitle="badge.subtitle"
                  :menu-value="badge.menuValue"
                  :lateral-menu-val="lateralMenuVal"
                  :disabled="!canAccessTab(badge.menuValue)"
                  :active-background-color="'#FF821A'"
                  :inactive-background-color="'#FF821A80'"
                  :hover-background-color="'#FF821A69'"
                  @update-lateral-menu="updateLateralMenu"
                />
              </div>
            </template>
            <span>{{ getTabBlockedReason(badge.menuValue) }}</span>
          </v-tooltip>
          <BadgeDt
            v-else
            :icon="badge.icon"
            :title="badge.title"
            :subtitle="badge.subtitle"
            :menu-value="badge.menuValue"
            :lateral-menu-val="lateralMenuVal"
            :disabled="!canAccessTab(badge.menuValue)"
            :active-background-color="'#FF821A'"
            :inactive-background-color="'#FF821A80'"
            :hover-background-color="'#FF821A69'"
            @update-lateral-menu="updateLateralMenu"
          />
        </div>
      </div>

      <div class="content-container">
        <DefinitionsTab
          ref="definitionsTab"
          v-show="lateralMenuVal === 'definitions'"
          :users-list="users"
          :vehicles-list="vehicles"
          :drivers-list="drivers"
          :solic-data="solicData"
          :is-edit-mode="isEditMode && editModeTab === 'definitions'"
          @updateTable="$emit('updateTable')"
          @close="closeModal"
          @data-changed="onDataChanged"
        >
          <template #actions>
            <v-btn
              color="info"
              @click="handleNext"
            >
              <span>PRÓXIMO</span>
              <v-icon
                size="20"
                class="ml-2"
              >
                {{ icons.mdiArrowRight }}
              </v-icon>
            </v-btn>
          </template>
        </DefinitionsTab>

        <SolicitationTab
          ref="solicitationTab"
          v-show="lateralMenuVal === 'solicitation'"
          :solic-data="solicData"
          :users-list="users"
          :vehicles-list="vehicles"
          :drivers-list="drivers"
          :is-edit-mode="isEditMode && editModeTab === 'solicitation'"
          @updateTable="$emit('updateTable')"
          @close="closeModal"
          @data-changed="onDataChanged"
        >
          <!-- <template #actions>
            <v-btn
              color="white"
              outlined
              @click="handlePrevious"
            >
              <v-icon
                size="20"
                class="mr-2"
              >
                {{ icons.mdiArrowLeft }}
              </v-icon>
              <span>Anterior</span>
            </v-btn>
            <v-btn
              color="info"
              @click="handleNext"
            >
              <span>PRÓXIMO</span>
              <v-icon
                size="20"
                class="ml-2"
              >
                {{ icons.mdiArrowRight }}
              </v-icon>
            </v-btn>
          </template> -->
        </SolicitationTab>

        <ChecklistTab
          v-show="lateralMenuVal === 'checklist'"
          :solic-data="solicData"
          :users-list="users"
          :vehicles-list="vehicles"
          :drivers-list="drivers"
          @updateTable="$emit('updateTable')"
          @close="closeModal"
          @go-back-tab="handlePrevious"
          @open-parent-solicitation="handleOpenParentSolicitation"
        >
          <template #actions>
            <v-btn
              color="white"
              outlined
              @click="handlePrevious"
            >
              <v-icon
                size="20"
                class="mr-2"
              >
                {{ icons.mdiArrowLeft }}
              </v-icon>
              <span>Anterior</span>
            </v-btn>
            <!-- <v-btn
              color="info"
              @click="handleFinish"
            >
              <span>Finalizar</span>
              <v-icon
                size="20"
                class="ml-2"
              >
                {{ icons.mdiCheck }}
              </v-icon>
            </v-btn> -->
          </template>
        </ChecklistTab>

        <TripTab
          v-show="lateralMenuVal === 'trip'"
          :solic-data="solicData"
          :users-list="users"
          :vehicles-list="vehicles"
          :drivers-list="drivers"
          @updateTable="$emit('updateTable')"
          @close="closeModal"
          @go-back-tab="handlePrevious"
          @open-parent-solicitation="handleOpenParentSolicitation"
        />
      </div>
      <v-dialog
        v-model="showHistoryModal"
        max-width="800"
        transition="dialog-bottom-transition"
      >
        <HistoryModal v-if="showHistoryModal" @close="showHistoryModal = false" :solicData="solicData" />
      </v-dialog>
      <v-dialog
        v-model="showCancelModal"
        max-width="600"
        transition="dialog-bottom-transition"
      >
        <CancelSolicitationModal
          :solic-data="solicData"
          @close="showCancelModal = false"
          @cancel-success="handleCancelSuccess"
        />
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import BadgeDt from '@/views/pages/Solicitations/Marketing/Solicitations/components/BadgeDt.vue';
import {
  mdiArrowLeft,
  mdiArrowRight,
  mdiCancel,
  mdiCarHatchback,
  mdiCheck,
  mdiCheckboxMarkedCircleOutline,
  mdiClose,
  mdiCog,
  mdiCogOutline,
  mdiContentSave,
  mdiFileDocumentOutline,
  mdiPencil,
  mdiTimelineCheckOutline,
} from '@mdi/js';
import CancelSolicitationModal from './CancelSolicitationModal.vue';
import HistoryModal from './HistoryModal.vue';
import ChecklistTab from './tabs/ChecklistTab.vue';
import DefinitionsTab from './tabs/DefinitionsTab.vue';
import SolicitationTab from './tabs/SolicitationTab.vue';
import TripTab from './tabs/TripTab.vue';

export default {
  name: 'TransportAdmSolicModal',
  components: {
    BadgeDt,
    DefinitionsTab,
    SolicitationTab,
    ChecklistTab,
    HistoryModal,
    CancelSolicitationModal,
    TripTab,
  },
  props: {
    solicData: {
      type: Object,
      default: () => ({}),
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    vehiclesList: {
      type: Array,
      default: () => [],
    },
    driversList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      icons: {
        mdiTimelineCheckOutline,
        mdiClose,
        mdiArrowLeft,
        mdiArrowRight,
        mdiCheck,
        mdiContentSave,
        mdiCog,
      },
      drivers: this.driversList || [],
      users: this.usersList || [],
      vehicles: this.vehiclesList || [],
      lateralMenuVal: 'definitions',
      showOptionsMenu: false,
      showHistoryModal: false,
      showCancelModal: false,
      showSaveButton: false,
      isEditMode: false,
      hasUnsavedChanges: false,
      editModeTab: null, // 'definitions', 'solicitation'
      menuOptions: [
        {
          icon: mdiPencil,
          title: 'Editar',
          action: 'edit',
          iconColor: '#E7E3FC',
        },
        {
          icon: mdiCancel,
          title: 'Cancelar solicitação',
          action: 'cancel-request',
          iconColor: '#FF4C51',
        },
      ],
      badges: [
        {
          icon: mdiCogOutline,
          title: 'Definições',
          subtitle: 'Defina as categorias',
          menuValue: 'definitions',
        },
        {
          icon: mdiFileDocumentOutline,
          title: 'Solicitação',
          subtitle: 'Insira os dados',
          menuValue: 'solicitation',
        },
        {
          icon: mdiCheckboxMarkedCircleOutline,
          title: 'Checklist',
          subtitle: 'Verificar veículo',
          menuValue: 'checklist',
        },
        {
          icon: mdiCarHatchback,
          title: 'Viagem',
          subtitle: 'Detalhes de trânsito',
          menuValue: 'trip',
        },
      ],
    }
  },

  computed: {
    currentTabIndex() {
      return this.badges.findIndex(b => b.menuValue === this.lateralMenuVal)
    },
    isFirstTab() {
      return this.currentTabIndex === 0
    },
    isLastTab() {
      return this.currentTabIndex === this.badges.length - 1
    },
    canNavigateNext() {
      if (this.isLastTab) return false
      const nextBadge = this.badges[this.currentTabIndex + 1]

      return nextBadge ? this.canAccessTab(nextBadge.menuValue) : false
    },
    canNavigatePrevious() {
      return !this.isFirstTab
    },
    nextButtonDisabled() {
      return !this.canNavigateNext
    },

    filteredMenuOptions() {
      if (this.lateralMenuVal === 'checklist') {
        return this.menuOptions.filter(option => option.action === 'cancel-request')
      }

      return this.menuOptions
    },
    canShowTripTab() {
      const status = String(this.solicData?.status || '').trim().toLowerCase()
      const typeChecklist = String(this.solicData?.checklist_type || '').trim().toLowerCase()

      return (
        ['aguardando iniciar', 'em trânsito', 'finalizada', 'cancelada'].includes(status)
        || (status === 'em checklist' && typeChecklist === 'end')
      )
    },
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    openHistoryModal() {
      this.showHistoryModal = true
    },
    handleMenuOption(action) {
      this.showOptionsMenu = false

      switch (action) {
        case 'edit':
          this.isEditMode = true
          this.editModeTab = this.lateralMenuVal
          this.showSaveButton = true
          this.enableEditMode()

          break
        case 'save':
          this.handleSaveCurrentTab()

          break
        case 'cancel-edit':
          this.handleCancelEdit()

          break
        case 'cancel-request':
          this.handleCancelRequest()

          break
        default:
      }
    },
    canAccessTab(menuValue) {
      return menuValue !== 'trip' || this.canShowTripTab
    },
    getTabBlockedReason() {
      return 'Complete a etapa anterior para continuar'
    },
    async updateLateralMenu(val) {
      if (!this.canAccessTab(val)) {
        return
      }

      // Verifica se há mudanças não salvas antes de trocar de tab
      const canProceed = await this.checkUnsavedChanges()
      if (!canProceed) {
        return
      }

      // Reset do estado de edição ao trocar de tab
      this.exitEditMode()
      this.lateralMenuVal = val
    },
    handleNext() {
      const currentIndex = this.badges.findIndex(b => b.menuValue === this.lateralMenuVal)
      const nextBadge = this.badges[currentIndex + 1]

      if (nextBadge) {
        this.updateLateralMenu(nextBadge.menuValue)
      }
    },
    handlePrevious() {
      const currentIndex = this.badges.findIndex(b => b.menuValue === this.lateralMenuVal)
      const prevBadge = this.badges[currentIndex - 1]

      if (prevBadge) {
        this.updateLateralMenu(prevBadge.menuValue)
      }
    },
    handleFinish() {

      this.closeModal()
    },

    enableEditMode() {
      // Habilita o modo de edição na tab atual
      this.$refs[`${this.lateralMenuVal}Tab`]?.enableEditMode?.()
    },

    handleSaveCurrentTab() {
      // Salva dados da tab atual
      if (this.lateralMenuVal === 'definitions') {
        this.saveDefinitions()
      } else if (this.lateralMenuVal === 'solicitation') {
        this.saveSolicitationData()
      }
    },

    handleCancelEdit() {
      // Cancela edição e restaura dados originais
      this.$refs[`${this.lateralMenuVal}Tab`]?.cancelEdit?.()
      this.exitEditMode()
    },

    exitEditMode() {
      this.isEditMode = false
      this.editModeTab = null
      this.showSaveButton = false
      this.hasUnsavedChanges = false
    },

    async saveDefinitions() {
      try {
        const success = await this.$refs.definitionsTab?.saveDefinitions?.()
        if (success) {
          this.exitEditMode()
          this.$emit('updateTable')
        }
      } catch (error) {
        console.error('Erro ao salvar definições:', error)
      }
    },

    async saveSolicitationData() {
      try {
        const success = await this.$refs.solicitationTab?.saveSolicitationData?.()
        if (success) {
          this.exitEditMode()
          this.$emit('updateTable')
        }
      } catch (error) {
        console.error('Erro ao salvar dados da solicitação:', error)
      }
    },

    async checkUnsavedChanges() {
      if (!this.isEditMode || !this.hasUnsavedChanges) {
        return true
      }

      const result = await this.$swal({
        title: 'Dados não salvos',
        text: 'Tem certeza? Você irá perder os dados alterados.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, continuar',
        cancelButtonText: 'Não, permanecer aqui',
        reverseButtons: true,
      })

      return result.isConfirmed
    },

    onDataChanged() {
      this.hasUnsavedChanges = true
    },

    async handleCancelRequest() {
      const result = await this.$swal({
        title: 'Aviso!',
        text: 'Tem certeza que deseja cancelar esta solicitação?\nAo clicar em sim, não será mais possível realizar edições.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        reverseButtons: true,
      })

      if (result.isConfirmed) {
        this.showCancelModal = true
      }
    },

    handleCancelSuccess() {
      this.showCancelModal = false
      this.$emit('updateTable')
      this.closeModal()
    },

    handleOpenParentSolicitation(parentSolicitationId) {
      // Emite evento para o componente pai (Home.vue) abrir a solicitação pai
      this.$emit('open-parent-solicitation', parentSolicitationId)
    },
  },
}
</script>

<style scoped>
.modal-header {
  width: 100%;
  position: relative;
}

.modal-title {
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  padding-top: 30px;
}

.options-container {
  display: flex;
  align-items: center;
  gap: 10px;
  position: absolute;
  right: 20px;
  top: 25px;
}

.modal-content {
  margin-left: 28px;
  margin-right: 28px;
  display: flex;
  margin-top: 32px;
  align-items: flex-start;
  padding-bottom: 48px;
  gap: 10px;
}

.tabs-container {
  width: 20%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.badge-item {
  display: flex;
  min-width: 203px;
  align-items: center;
  gap: 10px;
}

.badge-item div {
  min-width: 203px;
}

.content-container {
  width: 80%;
}

.options-menu-card {
  background-color: #312D4B !important;
  min-width: 200px;
  padding: 8px 0;
}

.option-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 6px;
  margin: 2px 8px;
  position: relative;
  overflow: hidden;
}

.option-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(231, 227, 252, 0.1), transparent);
  transition: left 0.5s ease;
}

.option-item:hover {
  background-color: #3B355A;
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.option-item:hover::before {
  left: 100%;
}

.option-item:hover .v-icon {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.option-item:active {
  transform: translateX(2px) scale(0.98);
  transition: transform 0.1s ease;
}

.option-item .v-icon {
  transition: all 0.3s ease;
}

.option-item span {
  transition: all 0.3s ease;
  font-size: 14px;
}

@media (max-width: 1133px) {
  .modal-content {
    flex-direction: column;
    gap: 20px;
  }

  .tabs-container {
    width: 100%;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  .content-container {
    width: 100%;
  }
}
</style>
